import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { SurfaceTier } from '@app/core/models/types/surface-tier.type';
import { BootstrapThemeService } from '@app/core/services/bootstrap-theme.service';
import { SurfaceTierThemeService, SurfaceTierThemeType } from '@app/core/services/surface-tier-theme.service';
import { AlertComponent } from '@app/modules/alerts/components/alert/alert.component';

export enum AlertDirection {
    ROW,
    COLUMN
}

@Component({
    selector: 'fdx-surface-alert',
    templateUrl: './surface-alert.component.html',
    styleUrl: './surface-alert.component.scss',
    standalone: false
})
export class SurfaceAlertComponent extends AlertComponent implements OnInit {

    /**
     * Which tier to use for this button or badge.
     * Defaults to 'retail'.
     */
    @Input() tier: SurfaceTier = 'retail';

    protected tierThemeType: SurfaceTierThemeType;

    get tierAlertClasses(): string {
        return `alert-${this.tier}`
    }

    constructor(
        protected readonly bootstrapThemeService: BootstrapThemeService,
        protected readonly host: ElementRef<HTMLElement>,
        protected readonly surfaceTierTheme: SurfaceTierThemeService
    ) {
        super(bootstrapThemeService, host);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.tierThemeType = this.surfaceTierTheme.getTierThemeType(this.tier);
    }
}
